import React, { Component } from 'react';
import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
import swal from '@sweetalert/with-react'
import { icon } from '@fortawesome/fontawesome-svg-core';
import { uploadVersionFile } from '../store/actions/fileActions.js'
import { postComment, changeDocStatus } from '../store/actions/poDetailsActions.js';
// import { postComment } from '../store/actions/poDetailsActions.js';
import AuthHandlerInstance from '../Classes/AuthHandler';

class DocumentRevisePopUp extends React.Component {
    constructor(props) {
        super(props);
        console.log(this.props, 'popup props')
        this.state = {
            showRevisedPopUp: this.props.showRevisedPopUp,
            revisedPayload: this.props.revisedPayload,
            selectedfilestageIdVersion: [],//Keep documentTypeId
            stageIdsVersion: [], //
            fileUploadIds: [],//upload id
            purchaseLIneItemID: this.props.purchaseLIneItemID,
            purchaseOrderId: this.props.purchaseOrderId,
            comments: [],
            qATemplateStageId: this.props.revisedPayload.qATemplateStageId,
            PoDocumentId: [],
            docStatus: {
                1: { title: "Saved as draft", badge: "badge-secondary" },
                2: { title: "Document saved", badge: "badge-warning" },
                3: { title: "Accepted", badge: "badge-success" },
                4: { title: "Rejected", badge: "badge-danger" },
                5: { title: "Required another revised document", badge: "badge-danger" }
            },

            reviseForm: {
                file: [],
                comment: ""
            }
        }
        this.changeDocStatus = this.changeDocStatus.bind(this);
    }

    componentWillMount() {

    }

    async changeDocStatus(status, uploadId, QATemplateStageId, poId, actedBy, comment) {
        this.props.changeDocStatus({ status, uploadId, QATemplateStageId, poId, actedBy, comment });
    }

    dateformate(dateVal) {
        let d = new Date(dateVal);
        return d.toDateString();
    }

    revisePopUpAction(st) {
        this.props.revisePopUpAction({}, false, true)
    }

    formSaveAction = async () => {
        var param = {
            files: this.state.reviseForm.file,
            comment: this.state.reviseForm.comment,
        }
        this.props.submitPopUpForm(param)
        // if (this.state.reviseForm.file.length < 1) {
        //     var roles = AuthHandlerInstance.getRoles()
        //     var IsSMS = 0
        //     if (roles["5"]) {
        //         IsSMS = 0
        //     } else {
        //         IsSMS = 1
        //     }
        //     let param = {
        //         purchaseLIneItemID: this.state.purchaseLIneItemID,
        //         purchaseOrderId: this.state.purchaseOrderId,
        //         stageDocumentId: this.state.revisedPayload.param.stageDocumentId,
        //         status: this.state.revisedPayload.param.Status,
        //         uploadId: this.state.fileUploadIds,
        //         comment: this.state.reviseForm.comment,
        //         DocumentTypeId: this.state.revisedPayload.param.DocumentTypeId,
        //         IsSMS: IsSMS,
        //         actedBy: AuthHandlerInstance.getUserID()
        //     }

        //     this.props.submitPopUpForm(param)
        //     // await this.props.postComment(param)
        //     // swal("Saving...",{icon:"info",button:false})
        //     // if (this.state.revisedPayload.status === 3) {
        //     //     await this.changeDocStatus(3,this.state.revisedPayload.param.uploadId,this.state.qATemplateStageId,this.state.purchaseOrderId, AuthHandlerInstance.getUserID(), this.state.reviseForm.comment)
        //     // } else {
        //     //     await this.changeDocStatus(5,this.state.revisedPayload.param.uploadId,this.state.qATemplateStageId,this.state.purchaseOrderId, AuthHandlerInstance.getUserID(), this.state.reviseForm.comment)
        //     // }
        //     // await this.revisePopUpAction(false); 

        // }
        // else {
        //     swal("Saving...", { icon: "info", button: false });
        //     let comments = [this.state.reviseForm.comment];
        //     if (this.state.revisedPayload.status === 3) {
        //         await this.props.uploadVersionFile(this.state.reviseForm.file,
        //             this.state.selectedfilestageIdVersion,
        //             this.state.purchaseOrderId,
        //             this.state.purchaseLIneItemID,
        //             this.state.stageIdsVersion,
        //             this.state.fileUploadIds, comments, [3], AuthHandlerInstance.getUserID(), this.state.qATemplateStageId);
        //     } else {
        //         await this.props.uploadVersionFile(this.state.reviseForm.file,
        //             this.state.selectedfilestageIdVersion,
        //             this.state.purchaseOrderId,
        //             this.state.purchaseLIneItemID,
        //             this.state.stageIdsVersion,
        //             this.state.fileUploadIds, comments, [5], AuthHandlerInstance.getUserID(), this.state.qATemplateStageId);
        //     }

        //     this.revisePopUpAction(false);
        // }
    }

    handleFileInput = (event) => {
        let fileList = [];
        fileList.push(event.target.files[0])
        let reviseForm = this.state.reviseForm
        reviseForm.file = fileList

        let selectedfilestageIdVersion = [this.state.revisedPayload.param.documentTypeId]
        let stageIdsVersion = [this.state.revisedPayload.param.stageDocumentId];
        let fileUploadIds = [this.state.revisedPayload.param.uploadId]
        this.setState({ reviseForm, selectedfilestageIdVersion, stageIdsVersion, fileUploadIds });
    }

    formChange = (e) => {
        console.log("Event", e.target.value);
        let reviseForm = this.state.reviseForm
        reviseForm.comment = e.target.value;
        this.setState({ reviseForm });
    }

    render() {
        return (
            this.state.showRevisedPopUp && <Modal isOpen={this.state.showRevisedPopUp} >
                <div className={"modal-bg" + (this.state.OpenVersionModal == true ? 'open' : '')}>
                    <div className="modalheads">
                        <ModalHeader HeaderStyle="modal-header">
                            <div className="modal-text"><h4 >{`${this.state.revisedPayload.param.DocumentTypeName}`}</h4></div>
                            <button type="button" className="close" aria-label="Close" onClick={(e) => this.revisePopUpAction(false)} >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </ModalHeader>
                    </div>
                    <div>
                        <ModalBody Style="modal-body modalbodys">

                            <div className="row ">
                                <div className="col-8"></div>
                                <div className="col-4 pb-2">
                                    {/* <DropdownFlat defaultopt="-Select-"  data={this.state.Date} actions={this.handleSelect} keyObjName={"value"} valueObjName={"label"} /> */}
                                </div>
                            </div>

                            <div className="row col-sm-12" style={{ textAlign: "center", display: "none", top: "40%" }}>
                                <div className="spinner-border" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>

                            <div className="row ">
                                <div className="col-sm-6">
                                    {this.state.revisedPayload.status == 3 ? 'Upload Signed Document' : 'Upload Revise Document'}
                                    (Optional)
                                </div>
                                <div className="col-sm-6">
                                    <input type="file" className="form-control-file" name="" onChange={(e) => { this.handleFileInput(e) }} id="exampleFormControlFile2" />
                                </div>
                            </div>

                            <div className="row mt-4">
                                <div className="col-sm-6">
                                    Comment
                                </div>
                                <div className="col-sm-6">
                                    <textarea className="form-control" onChange={(e) => this.formChange(e)} value={this.state.reviseForm.comment}></textarea>
                                </div>
                            </div>
                        </ModalBody>
                    </div>
                    <div className="">
                        <ModalFooter FooterStyle="modal-footer">
                            <div>
                                <button className="btn2 btn-sms1 mt-2 ml-2 float-right" onClick={() => this.formSaveAction()} type="submit">{this.state.revisedPayload.status == 3 ? 'Accept' : 'Save'}</button>
                                <button className="btn2 btn-sms1 mt-2 ml-2 " onClick={() => this.revisePopUpAction(false)} type="submit">Close</button>

                            </div>
                        </ModalFooter>
                    </div>
                </div>
            </Modal>

        )
    }
}

const mapStateToProps = (state) => ({
    comment: state.comment,
})
// export default connect(mapStateToProps, {uploadVersionFile,postComment})(DocumentRevisePopUp)
export default connect(mapStateToProps, { uploadVersionFile, postComment, changeDocStatus })(DocumentRevisePopUp)